import { getArgsAsTypesafeObjectProperties } from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties('GET_NOTIFICATION_HISTORY', 'UPDATE_PICK_UP_AMOUNT');
